import * as React from "react";
import Styles from "../styles/main.module.css";
import { DataGrid } from "@mui/x-data-grid";
import "../styles/settlementTable.css";
import { useNavigate } from "react-router-dom";
import { useStateValue } from "../../../../Hooks/stateProvider";
import CustomNoRowsOverlay from "../../../../components/CustomNoRowsOverlay";
import Loader from "../../../../Loader/Loader";

export default function SettlementTable(props) {
  const navigate = useNavigate();
  const [state, dispatch] = useStateValue();

  const columns = [
    {
      field: "alertname",
      headerName: "Alert Name",
      minWidth: 150,
      flex: 1,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "count",
      headerName: "Instance Count",
      minWidth: 350,
      flex: 1,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "pmsstatus",
      headerName: "Status",
      minWidth: 150,
      flex: 1,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "View",
      headerName: "",
      minWidth: 150,
      flex: 1,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: "center", }}>
            <div style={{ paddingRight: "5px" }}>
            </div>
            <div style={{ paddingLeft: "5px" }}>
              <button
                // className="takeAction"
                className={Styles.Preview}
                style={{
                  backgroundColor: params.row.pmsstatus === 'Pending' ? "#154063" : "#808080",
                  cursor: params.row.pmsstatus === 'Pending' ? "pointer" : "default",
                  border: params.row.pmsstatus === 'Pending' ? "0.125rem solid #154063" : "0.125rem solid #808080",
                }}
                // className={params.row.pmsstatus == 'Pending'? "takeAction" : "takeActionDisabled"}
                onClick={() => {
                  dispatch({ type: "alertName", alertName: params.row.alertname })
                  dispatch({ type: "alertDescription", alertDescription: params.row.annexure_description })
                  navigate("/app/takeAction", { state: { columnsName: params.row.original_name_of_columns, instanceCount: params.row.count } });
                }}
                disabled={params.row.pmsstatus === 'Pending'? false: true}
              >
                Take Action
              </button>
            </div>
          </div>
        );
      },
    },
  ];



  return (
    <div style={{ height: "100%", width: "100%", }}>
      <Loader />
      <DataGrid
        getRowHeight={() => "auto"}
        rows={props.rows}
        columns={columns}
        sx={{
          width: "fit-content",
          "& .MuiDataGrid-columnHeaderTitleContainer": {
            justifyContent: "center",
            backgroundColor: "#154063",
          },
          "& .MuiDataGrid-withBorderColor": {
            borderRight: "none",
          },
          "& .MuiDataGrid-columnSeparator--sideRight": { display: "none" },
          "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
            display: "none",
          },
          "& .MuiDataGrid-topContainer": { width: "fit-content" },
          "& .MuiDataGrid-columnHeaders": { width: "fit-content" },
          "& .MuiDataGrid-cell": {
            whiteSpace: "normal",
            wordWrap: "break-word",
          },
          "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "5px" },
          "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
            py: "8px",
          },
          "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
            py: "15px",
          },
          "& .MuiDataGrid-cell": {
            whiteSpace: "normal",
            wordWrap: "break-word",
          },
          "& .MuiDataGrid-overlayWrapper": {
            position: "static"
          }
        }}
        style={{
          color: "#154063",
          width: "100%",
          whiteSpace: "nowrap",
          height: "100%",
          borderWidth: "2px",
          borderRadius: "10px",
        }}
        slots={{
          noRowsOverlay: CustomNoRowsOverlay
        }}
        rowsPerPageOptions={[2, 5, 10]}
        AutoGenerateColumns={false}
        disableRowSelectionOnClick
        disableColumnMenu
        disableRowCount
        disableColumnSelector
        scrollbarSize={0}
        autoPageSize
      />
    </div>
  );
}
